import React from 'react';

const HomePageJumbotron = () => {
    return (
        <div className="jumbotron jumbotron-fluid" />
    );
};

export default HomePageJumbotron;



// WEBPACK FOOTER //
// ./src/components/homePage/HomePageJumbotron.js